import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/variables.css';
import './styles/mobile.css';
import App from './App';
import * as sw from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Le composant racine est re-rendu quand une mise a jour est prete : c'est le
// seul moyen de remonter l'evenement du service worker jusqu'a l'interface.
const rendre = (enregistrementSW) => root.render(
  <React.StrictMode>
    <App enregistrementSW={enregistrementSW} />
  </React.StrictMode>
);

rendre(null);
sw.register({ onUpdate: (enregistrement) => rendre(enregistrement) });
